import {formatISO} from "date-fns";
import API from './API';
import {SHOP_CLOSURE_API} from '../constants/Constants';

export function getShopClosure() {
    return API({
        name: 'shop_closures',
        method: 'get',
        url: `${SHOP_CLOSURE_API}?date=${formatISO(new Date(), { representation: 'date' })}`
    });
}